import { useEffect, useState } from 'react';
import { BlockProps } from '@/components/Block/Block';
import styles from './MediaMachineBlock.module.sass';
import P from '@/components/Redactie/P/P';
import MediaMachine from '@/components/MediaMachine/MediaMachine';
import BlockEditorContainer from '../../BlockEditorContainer';
import { MediaMachineTypes } from '@/components/MediaMachine/MediaMachineAI';

interface MediaMachineMiniBlockData {
    type: string;
    classes: string[];
}

const MediaMachineMiniBlock = ({
    uuid,
    data,
    isEditable,
    onEdited,
    onFinished,
}: BlockProps) => {
    const [blockData, setBlockData] = useState<MediaMachineMiniBlockData>({
        type: data.type ?? Object.keys(MediaMachineTypes)[0],
        classes: data.classes ?? ['👍', '👎'],
    });

    useEffect(() => {
        if (!isEditable) return;
        onEdited?.({
            uuid,
            data: JSON.parse(JSON.stringify(blockData)),
            attachments: {},
        });
    }, [blockData]);

    return (
        <>
            {!isEditable && (
                <div className={styles.mediamachineblock}>
                    <MediaMachine
                        machineTypeId={blockData.type}
                        isEmbedded={true}
                        preferredCategoryNames={blockData.classes}
                        onMinimumSamplesRecorded={() => onFinished?.()}
                    />
                </div>
            )}
            {isEditable && (
                <BlockEditorContainer className="bg-slate-200">
                    <div className="grid grid-cols-2 gap-2">
                        {blockData.classes.map((className, index) => (
                            <P
                                key={index}
                                isEditable={true}
                                value={className}
                                rows={1}
                                maxLength={4}
                                placeholder={`Categorie ${index + 1}`}
                                onChange={(value) => {
                                    const newClasses = blockData.classes;
                                    newClasses[index] = value;
                                    setBlockData({
                                        ...blockData,
                                        classes: newClasses,
                                    });
                                }}
                            />
                        ))}
                    </div>
                </BlockEditorContainer>
            )}
        </>
    );
};

export default MediaMachineMiniBlock;
